module.exports = function() {
  return new Worker(__webpack_public_path__ + "ffb85d092d0ef1ec31bc.worker.js");
};